<div class="row">
  <div class="col-12 col-md-12 col-lg-12">
    <div *ngFor="let item of showFaqList; let idx = index">
      <div class="row">
        <div class="col-11" [ngClass]="idx === 0 ? 'm-t-lg' : 'm-t-xl'">
          <p for="title" class="lead bold" [innerHTML]="item.question"></p>
        </div>
      </div>
      <div class="row" *ngIf="item.answer">
        <div class="col-12">
          <p for="title" class="m-t-sm" [innerHTML]="item.answer"></p>
        </div>
      </div>
    </div>
    <div class="row m-t-xl">
      <div class="col-12">
        <hr class="divider" />
      </div>
    </div>
    <div class="row">
      <div class="col-11 m-t-lg">
        <a
          attr.aria-label="{{ seeAllLabel }}"
          href="javascript:void(0)"
          [hidden]="showAll"
          (click)="getAllFaq()"
          class="lead bold"
          id="cta-see-all-label"
          >{{ seeAllLabel }}</a
        >
        <a
          attr.aria-label="{{ seeLessLabel }}"
          href="javascript:void(0)"
          [hidden]="!showAll"
          (click)="showLessFaq()"
          class="lead bold"
          id="cta-see-less-label"
          >{{ seeLessLabel }}</a
        >
      </div>
    </div>
  </div>
</div>
